export default __webpack_public_path__ + "static/media/review1.4487866e.jpg";